import {TimelineMax, TweenMax} from 'gsap';
const Shortcuts = require('../utils/Shortcuts');


const _constructTimeline = (instance, config) => {
    const tl = new TimelineMax({paused: true});

    TweenMax.set(instance.root, {alpha: 0});
    tl.set(instance.root, {alpha: 0});

    tl.to(instance.root, config.inDuration, {alpha: 1});
    tl.to(instance.root, config.idleDuration, {alpha: 1});
    tl.to(instance.root, config.outDuration, {alpha: 0});

    instance.timeline = tl;
    return tl;
}


function FadeTransition(root, config) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;

        constructor.instance = {
            root: root
        };
        _created = true;

        return _constructTimeline(constructor['instance'], config);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = config.inDuration;
    constructor.totalDuration = config.inDuration + config.idleDuration + config.outDuration;

    return constructor;
}


module.exports = FadeTransition;



// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/transitions/DOMFadeTransition.js